// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Overrides for PrimeReact Components */

/* Paginator Visibility Fix - Force Dark Gray for better contrast against white backgrounds */
.p-paginator .p-paginator-pages .p-paginator-page,
.p-paginator .p-paginator-first,
.p-paginator .p-paginator-prev,
.p-paginator .p-paginator-next,
.p-paginator .p-paginator-last {
    color: #6c757d !important;
    font-weight: 600;
    opacity: 0.8;
}

.p-paginator .p-paginator-pages .p-paginator-page:hover,
.p-paginator .p-paginator-first:not(.p-disabled):hover,
.p-paginator .p-paginator-prev:not(.p-disabled):hover,
.p-paginator .p-paginator-next:not(.p-disabled):hover,
.p-paginator .p-paginator-last:not(.p-disabled):hover {
    background-color: #e9ecef;
    color: #2c3e50 !important;
    opacity: 1;
}

.p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    background: var(--theme-primary) !important;
    color: #ffffff !important;
    opacity: 1;
}

/* PrimeFlex Dark Mode Consistency */
.surface-card {
    background-color: var(--bg-card) !important;
    color: var(--text-primary) !important;
}

.surface-ground {
    background-color: var(--bg-page) !important;
}

.text-900 {
    color: var(--text-primary) !important;
    opacity: 1 !important;
}

.text-700 {
    color: var(--text-primary) !important;
}

.text-500 {
    color: var(--text-secondary) !important;
}

.border-300,
.border-400 {
    border-color: var(--border-color) !important;
}

/* Layout Consistency */
body {
    background-color: var(--bg-page);
    color: var(--text-primary);
    margin: 0;
}

/* DataTable Consistency */
.p-datatable .p-datatable-tbody>tr>td {
    background-color: var(--bg-card) !important;
    color: var(--text-primary) !important;
    border-color: var(--border-color) !important;
}

.p-paginator {
    background-color: var(--bg-page) !important;
    border-color: var(--border-color) !important;
}

/* Global Input Consistency for Dynamic Themes */
.p-inputtext,
.p-dropdown,
.p-password .p-inputtext,
.p-multiselect,
.p-calendar .p-inputtext,
.p-inputnumber .p-inputtext {
    background: var(--bg-card) !important;
    color: var(--text-primary) !important;
    border-color: var(--border-color) !important;
}

.p-inputtext:enabled:focus,
.p-dropdown.p-focus,
.p-multiselect.p-focus {
    border-color: var(--accent-color) !important;
    box-shadow: 0 0 0 0.1rem var(--accent-color) !important;
}

.p-inputtext::placeholder {
    color: var(--text-secondary) !important;
    opacity: 0.7;
}

.p-dropdown .p-dropdown-label.p-placeholder {
    color: var(--text-secondary) !important;
}

.p-dropdown-panel,
.p-multiselect-panel,
.p-autocomplete-panel {
    background: var(--bg-card) !important;
    color: var(--text-primary) !important;
    border-color: var(--border-color) !important;
}

.p-dropdown-items .p-dropdown-item,
.p-multiselect-items .p-multiselect-item {
    color: var(--text-primary) !important;
}

.p-dropdown-items .p-dropdown-item:hover,
.p-multiselect-items .p-multiselect-item:hover {
    background: var(--theme-primary-soft) !important;
}

.p-dropdown-items .p-dropdown-item.p-highlight,
.p-multiselect-items .p-multiselect-item.p-highlight {
    background: var(--accent-color) !important;
    color: var(--text-on-primary) !important;
}

/* Password eye icon consistency */
.p-password-icon {
    color: var(--text-secondary) !important;
}

/* Ensure labels in all forms follow the theme */
label {
    color: var(--text-primary) !important;
}`, "",{"version":3,"sources":["webpack://./src/GlobalOverrides.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C,6FAA6F;AAC7F;;;;;IAKI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;;;;IAKI,yBAAyB;IACzB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,2CAA2C;IAC3C,yBAAyB;IACzB,UAAU;AACd;;AAEA,oCAAoC;AACpC;IACI,2CAA2C;IAC3C,qCAAqC;AACzC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,4CAA4C;AAChD;;AAEA,uBAAuB;AACvB;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,SAAS;AACb;;AAEA,0BAA0B;AAC1B;IACI,2CAA2C;IAC3C,qCAAqC;IACrC,4CAA4C;AAChD;;AAEA;IACI,2CAA2C;IAC3C,4CAA4C;AAChD;;AAEA,gDAAgD;AAChD;;;;;;IAMI,qCAAqC;IACrC,qCAAqC;IACrC,4CAA4C;AAChD;;AAEA;;;IAGI,4CAA4C;IAC5C,uDAAuD;AAC3D;;AAEA;IACI,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;;IAGI,qCAAqC;IACrC,qCAAqC;IACrC,4CAA4C;AAChD;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;;IAEI,gDAAgD;AACpD;;AAEA;;IAEI,0CAA0C;IAC1C,wCAAwC;AAC5C;;AAEA,kCAAkC;AAClC;IACI,uCAAuC;AAC3C;;AAEA,gDAAgD;AAChD;IACI,qCAAqC;AACzC","sourcesContent":["/* Global Overrides for PrimeReact Components */\n\n/* Paginator Visibility Fix - Force Dark Gray for better contrast against white backgrounds */\n.p-paginator .p-paginator-pages .p-paginator-page,\n.p-paginator .p-paginator-first,\n.p-paginator .p-paginator-prev,\n.p-paginator .p-paginator-next,\n.p-paginator .p-paginator-last {\n    color: #6c757d !important;\n    font-weight: 600;\n    opacity: 0.8;\n}\n\n.p-paginator .p-paginator-pages .p-paginator-page:hover,\n.p-paginator .p-paginator-first:not(.p-disabled):hover,\n.p-paginator .p-paginator-prev:not(.p-disabled):hover,\n.p-paginator .p-paginator-next:not(.p-disabled):hover,\n.p-paginator .p-paginator-last:not(.p-disabled):hover {\n    background-color: #e9ecef;\n    color: #2c3e50 !important;\n    opacity: 1;\n}\n\n.p-paginator .p-paginator-pages .p-paginator-page.p-highlight {\n    background: var(--theme-primary) !important;\n    color: #ffffff !important;\n    opacity: 1;\n}\n\n/* PrimeFlex Dark Mode Consistency */\n.surface-card {\n    background-color: var(--bg-card) !important;\n    color: var(--text-primary) !important;\n}\n\n.surface-ground {\n    background-color: var(--bg-page) !important;\n}\n\n.text-900 {\n    color: var(--text-primary) !important;\n    opacity: 1 !important;\n}\n\n.text-700 {\n    color: var(--text-primary) !important;\n}\n\n.text-500 {\n    color: var(--text-secondary) !important;\n}\n\n.border-300,\n.border-400 {\n    border-color: var(--border-color) !important;\n}\n\n/* Layout Consistency */\nbody {\n    background-color: var(--bg-page);\n    color: var(--text-primary);\n    margin: 0;\n}\n\n/* DataTable Consistency */\n.p-datatable .p-datatable-tbody>tr>td {\n    background-color: var(--bg-card) !important;\n    color: var(--text-primary) !important;\n    border-color: var(--border-color) !important;\n}\n\n.p-paginator {\n    background-color: var(--bg-page) !important;\n    border-color: var(--border-color) !important;\n}\n\n/* Global Input Consistency for Dynamic Themes */\n.p-inputtext,\n.p-dropdown,\n.p-password .p-inputtext,\n.p-multiselect,\n.p-calendar .p-inputtext,\n.p-inputnumber .p-inputtext {\n    background: var(--bg-card) !important;\n    color: var(--text-primary) !important;\n    border-color: var(--border-color) !important;\n}\n\n.p-inputtext:enabled:focus,\n.p-dropdown.p-focus,\n.p-multiselect.p-focus {\n    border-color: var(--accent-color) !important;\n    box-shadow: 0 0 0 0.1rem var(--accent-color) !important;\n}\n\n.p-inputtext::placeholder {\n    color: var(--text-secondary) !important;\n    opacity: 0.7;\n}\n\n.p-dropdown .p-dropdown-label.p-placeholder {\n    color: var(--text-secondary) !important;\n}\n\n.p-dropdown-panel,\n.p-multiselect-panel,\n.p-autocomplete-panel {\n    background: var(--bg-card) !important;\n    color: var(--text-primary) !important;\n    border-color: var(--border-color) !important;\n}\n\n.p-dropdown-items .p-dropdown-item,\n.p-multiselect-items .p-multiselect-item {\n    color: var(--text-primary) !important;\n}\n\n.p-dropdown-items .p-dropdown-item:hover,\n.p-multiselect-items .p-multiselect-item:hover {\n    background: var(--theme-primary-soft) !important;\n}\n\n.p-dropdown-items .p-dropdown-item.p-highlight,\n.p-multiselect-items .p-multiselect-item.p-highlight {\n    background: var(--accent-color) !important;\n    color: var(--text-on-primary) !important;\n}\n\n/* Password eye icon consistency */\n.p-password-icon {\n    color: var(--text-secondary) !important;\n}\n\n/* Ensure labels in all forms follow the theme */\nlabel {\n    color: var(--text-primary) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
